import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-popin-content-header',
    templateUrl: './popin-content-header.component.html',
    styleUrls: [
        './popin-content-header.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopinContentHeaderComponent implements OnInit
{
    @Input() percentLeftPart: number = 100 / 3;
    @Input() percentMiddlePart: number;
    percentRightPart: number = 100 / 3;

    constructor() { }

    ngOnInit ()
    {
        this.percentRightPart = this.percentLeftPart;
    }
}
